import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { Loading } from './../../../components/includes/loading';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Upload } from './../../../components/includes/upload';
import { Ttolbar } from './../../../components/includes/ui/table';
import { SnackbarStatic } from './../../../components/includes/snackbar';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { AutogestionService } from './../../../services';
import { buildSlug } from './../../../utilities/utils';

import VALIDATION from './../../../config/validation';
import API from './../../../config/api';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class AutogestionUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      sending: false
    };
  }

  componentDidMount(){

    this._Find(this.props.match.params.id);

  }

  componentWillUnmount(){
    this.props.Clear();
  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    AutogestionService.find(id).then((response) => {

      // @State
      this.setState({ loading: true, id: id });

      // @Dispatch
      this.props.Update(response);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (values) => {

    // @Loading
    this.setState({ loading: false });

    // @Service
    AutogestionService.update(this.state.id, values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/autogestion');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exitio, el recurso fue editado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleSubmitForm = (values) => {
    this._Update(values);
  }

  /*
  ** @Service
  ** @Description: Attachments
  */

  onUploadImagen = (file) => {
    this.props.dispatch(change('AutogestionUpdate', 'path', file.attachment[0] ));
  }

  /*
  ** @Event
  ** @Description: Complete slug on change name
  */

  handleOnChangeName = (e) => {
    this.props.dispatch(change('AutogestionUpdate', 'slug', (buildSlug(e.target.value) )));
  }

  render() {

    const { loading, sending } = this.state;
    const { AutogestionUpdate, handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Autogestion"/>
        <BreadcrumbItem to='/autogestion'>Autogestion</BreadcrumbItem>
        <BreadcrumbItem to='/update'>Editar</BreadcrumbItem>
        <Content>

          <Main>

            { loading ? (

              <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

                <Ttolbar title="Edición de recurso"/>

                <FormContent enabledActions>

                  <Grid container spacing={24}>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SnackbarStatic
                        icon="info"
                        variant="warning"
                        message={`Formatos soportados: ${ API.upload.attachment_available_ext.join(', ') }`}
                        open={true}
                        fullWidth hideClose/>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="name"
                          component={ InputTextField }
                          label="Nombre"
                          type="text"
                          required
                          onChange={ this.handleOnChangeName }
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="status"
                          component={ SelectField }
                          label="Estado" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="true" value="true">Activo</OptionField>
                            <OptionField key="false" value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="path"
                          type="hidden"
                          component={ InputTextField }
                      />
                      <Upload
                        button="Subir archivo"
                        file={ AutogestionUpdate.path }
                        onSuccess={ this.onUploadImagen.bind(this) }
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="slug"
                          component={ InputTextField }
                          label="Slug"
                          type="text"
                          required
                      />
                    </Grid>

                  </Grid>

                </FormContent>

                <FormActions>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons>
                        <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/autogestion">
                          Volver
                        </Btn>
                      </Buttons>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons align="right">
                        <Btn aria-label="Guardar recurso" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                          Guardar
                        </Btn>
                      </Buttons>
                    </Grid>
                  </Grid>
                </FormActions>

              </form>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }
}

AutogestionUpdate = reduxForm({
  form: 'AutogestionUpdate',
  validate,
  enableReinitialize: true
})(AutogestionUpdate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    AutogestionUpdate: state.AutogestionUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'AUTOGESTION_UPDATE',
        data: data
      });
    },
    Clear: (data) => {
      dispatch({
        type: 'AUTOGESTION_UPDATE_CLEAR',
        data: data
      });
    }
  }
}

AutogestionUpdate = connect(
  state => ({
    initialValues: {
      name: state.AutogestionUpdate.name,
      status: state.AutogestionUpdate.status,
      slug: state.AutogestionUpdate.slug
    }
  })
)(AutogestionUpdate);

export default connect(mapStateToProps, mapDispatchToProps)(AutogestionUpdate);
